import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";
import { useDebounce } from "stimulus-use";

export default class extends Controller {
  static targets = ["select", "submitButton"];

  static classes = ["hidden"];

  static debounces = [{ name: "handleSearch", wait: 250 }];

  connect() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.classList.add(this.hiddenClass);
    }

    if (this.hasSelectTarget) {
      // Marks the first option as the placeholder.
      this.selectTarget.querySelector(
        "option:first-child",
      ).dataset.placeholder = "true";

      // Prevents the select from being translated by Google Translate.
      // On this page, when the select gets translated, the SlimSelect library
      // will change the DOM for it which will trigger a new translation by
      // Google Translate, which will change the DOM again, and so on.
      // Checking the value of the select in the submit method is not enough to
      // get the translation to work...
      this.selectTarget.classList.add("notranslate");

      this.statusSelect = new SlimSelect({
        select: this.selectTarget,
        settings: { allowDeselect: true, showSearch: true },
      });
    }

    useDebounce(this);
  }

  submit() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.click();
    }
  }

  handleSearch() {
    this.submit();
  }

  disconnect() {
    if (this.statusSelect) {
      this.statusSelect.destroy();
    }
  }
}
